// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum CtsGantryGridSourceEType {
  FIRST = 'first',
  SECOND = 'second',
}
